// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"388":"result","976":"share","982":"process"}[chunkId] + "." + {"388":"aa86e8f9","976":"64410a0d","982":"170c3c32"}[chunkId] + ".css";
};